import React from 'react'

export default function team() {
  return (
    <div className=" pt-6">
    <iframe
      src={"https://bobbysingh.me/"}
      style={{ width: "100%", height: "500px" }}
    ></iframe>
  </div>
  )
}
